import type { FaireProductEntity } from "../../entity_types/product";

export const p_hzhrdxkxtq: FaireProductEntity = {
  token: "p_hzhrdxkxtq",
  type: "product",
  name: "Woon White Rice",
  brandToken: "b_th428x9zzy",
  brandName: "Woon",
  imageUrl: "https://cdn.faire.com/fastly/905342db877950c0cb09754862bc5aa0f715c72a2436747d63977215bc4f9ab9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f2bb4c2b85cb8e2a25581283a08c7add0f19c5ae0431d53740b24b23331152a3.jpeg",
    "https://cdn.faire.com/fastly/d205c9e18027e738b17d0623dd0856704f713803e906096fea4711bdababbc31.jpeg",
    "https://cdn.faire.com/fastly/9faf81715c5a7a1ef5b75e62aa1d70c03d25b8b2b15c5dfe176038fd996ffd77.jpeg"
  ],
  priceDollars: 8,
  description: "It’s no secret that we use a lot of white rice in our restaurant. This is the same long grain Jasmine rice we use daily. It’s reliable and great for plain steamed rice or fried rice.\n\n𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\n• Rinse rice 2-3 times before cooking.\n• Use a 1:1 ratio for rice to water.",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:59.371Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
